import { LineUsage } from './line-usage';

export class UsageDetail extends LineUsage {
    public static storeName: string = 'usageDetail';
}
